import { ProjectsFilters } from "./types";

export const FILTER_ITEMS = [
    { id: ProjectsFilters.All, text: "activation.home.projects.filter.all.text" },
    { id: ProjectsFilters.My, text: "activation.home.projects.filter.my.text" },
    { id: ProjectsFilters.Inc, text: "activation.home.projects.filter.increasing.text" },
    { id: ProjectsFilters.Dec, text: "activation.home.projects.filter.decreasing.text" },
    { id: ProjectsFilters.NewAlert, text: "activation.home.projects.filter.newAlert.text" },
];
